import "@/components/report/iframeDetectForPv"
import "mptcfe-spm/dist/js/index"
import Vue from "vue";
import articleVideo from "./article_video"
import articleAbroad from './article_abroad'
import articleBussiness from './article_bussiness'
import toast from '../src/plugin/toast'
import { env } from "@/env"
import collection from "@/collection"
import contentControl from '@/components/contentControl'

// 全局挂载toast
Vue.use(toast)

require("./sass/main.less");

// 增加jquery等三方依赖，解决comment.js等cdn引入的js的报错
window.$ = window.jQuery = require('jquery')
window._ = require('underscore')

try {
    window.RUNNINGENV = RUNNINGENV
}catch(e){

}
try {
    window.sohu_mp = {
        env,
        article_abroad: articleAbroad,
        article_video: articleVideo,
        article_bussiness: articleBussiness,
        collection,
        contentControl
    }
}catch(e){
    console.log("初始化代码错误");
    throw e;
}

